import * as React from "react";

function SvgCartLogo(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={37.76} height={37.76} {...props}>
        <g data-name="Group 12421" transform="translate(-1524.843 -20.895)">
          <rect data-name="Rectangle 5" width={37.76} height={37.76} rx={13.285} transform="translate(1524.843 20.895)" fill="#ffe3e3" />
          <g data-name="Icon feather-shopping-cart" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round">
            <path data-name="Path 43160" d="M1541.105 48.224a.839.839 0 11-.84-.839.839.839 0 01.84.839z" strokeWidth={3} />
            <path data-name="Path 43161" d="M1550.339 48.224a.839.839 0 11-.84-.839.839.839 0 01.84.839z" strokeWidth={3} />
            <path
              data-name="Path 43162"
              d="M1533.55 31.436h3.358l2.25 11.24a1.679 1.679 0 001.679 1.351h8.159a1.679 1.679 0 001.679-1.351l1.342-7.04h-14.267"
              strokeWidth={1.4}
            />
          </g>
        </g>
      </svg>
    </span>
  );
}

export default SvgCartLogo;
